import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { NavigableMenu } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import classnames from 'classnames';
import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';
/**
 * Internal dependencies
 */

import { getHasItemsClass } from './utils';

var Menu = function Menu(_ref) {
  var label = _ref.label,
      orientation = _ref.orientation,
      itemCount = _ref.itemCount,
      items = _ref.items;
  var instanceId = uniqueId('woocommerce-summary-helptext-');
  var hasItemsClass = getHasItemsClass(itemCount);
  var classes = classnames('woocommerce-summary', _defineProperty({}, hasItemsClass, orientation === 'horizontal'));
  return createElement(NavigableMenu, {
    "aria-label": label,
    "aria-describedby": instanceId,
    orientation: orientation,
    stopNavigationEvents: true
  }, createElement("p", {
    id: instanceId,
    className: "screen-reader-text"
  }, __('List of data points available for filtering. Use arrow keys to cycle through ' + 'the list. Click a data point for a detailed report.', 'woocommerce-admin')), createElement("ul", {
    className: classes
  }, items));
};

Menu.propTypes = {
  /**
   * An optional label of this group, read to screen reader users.
   */
  label: PropTypes.string,

  /**
   * Item layout orientation.
   */
  orientation: PropTypes.oneOf(['vertical', 'horizontal']).isRequired,

  /**
   * A list of `<SummaryNumber />`s.
   */
  items: PropTypes.node.isRequired,

  /**
   * Number of items.
   */
  itemCount: PropTypes.number.isRequired
};
export default Menu;
//# sourceMappingURL=menu.js.map